<template>
    <div>
        <div class="head_bj">
            <div class="head">
                <myHead></myHead>
            </div>
            <div class="head_nr">
                <div class="pic yxdw">
                    <div class="pic_nr unit">
                        <div class="nr_title">
                            用信单位工作子平台
                        </div>
                        <div class="nr_details">
                            用信单位用户登录，受理企业融资业务，管理企业融资信息。
                        </div>
                        <button class="nr_btn">
                            <router-link :to="{name: 'LoginFinance'}"> 进入子平台
                            </router-link>
                        </button>
                    </div>
                </div>
                <div class="pic_interval"></div>
                <div class="pic zzgl">
                    <div class="pic_nr autonomy">
                        <div class="nr_title">
                            企业自主管理子平台
                        </div>
                        <div class="nr_details">
                            企业在已注册的情况下，依照融资平台的业务规范以及企业自身的实际需求，可以进行定制化服务。
                        </div>
                        <button class="nr_btn">
                            <router-link :to="{name: 'LoginCompany'}"> 进入子平台
                            </router-link>
                        </button>
                    </div>
                </div>
                <div class="pic_interval"></div>
                <div class="pic zxyy">
                    <div class="pic_nr operate">
                        <div class="nr_title">
                            征信运营管理子平台
                        </div>
                        <div class="nr_details">
                            运营单位管理人员登录。
                        </div>
                        <button class="nr_btn">
                            <router-link :to="{name: 'Login'}"> 进入子平台
                            </router-link>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>

    </div>
</template>

<script>
    import myHead from '@/components/indexHead/indexHead.vue'
    import myFooter from '@/components/indexFooter.vue'
    export default {
        components: {myHead,myFooter},
        data() {
            return {
            };
        }
    };
</script>

<style scoped lang="less">
    *{
        text-align: center;
    }
    .head_bj{
        width: 100%;
        height: 680px;
        background-image: url('../assets/img/bj.png');
        background-size: 100% 100%;
    }
    .head{
        width: 1100px;
        height: 80px;
        margin: 0 auto;
    }
    .head_nr{
        width: 1100px;
        height: 355px;
        margin: 0 auto;
        margin-top: 140px;
    }
    .pic{
        width: 348px;
        height: 355px;
        float: left;
    }
    .pic_interval{
        width: 28px;
        height: 355px;
        float: left;
    }
    .pic_nr{
        width: 348px;
        height: 355px;
        background-color: rgba(51,51,51,0.7);
        opacity: 0;
    }
    .nr_title{
        width: 100%;
        height: 77px;
        color: #fff;
        font-size: 22px;
        line-height: 77px;
    }
    .nr_details{
        padding: 0px 20px;
        color: #fff;
        font-size: 16px;
        text-align: left;
        line-height: 40px;
        text-indent: 2em;
        max-height: 200px;
        overflow-y: auto;
    }
    .nr_btn{
        width: 119px;
        height: 38px;
        border: 0;
        background-color: #4e95ff;
        color: #fff;
        font-size: 16px;
        margin-top: 20px;
    }
    .nr_btn a{
        color: #fff;
        font-size: 16px;
        text-decoration: none;
    }
    .yxdw{
        background-image: url('../assets/img/platform1.png');
    }
    .yxdw:hover .unit{
        opacity: 1;
    }
    .zzgl{
        background-image: url('../assets/img/platform2.png');
    }
    .zzgl:hover .autonomy{
        opacity: 1;
    }
    .zxyy{
        background-image: url('../assets/img/platform3.png');
    }
    .zxyy:hover .operate{
        opacity: 1;
    }
    //滚动条样
    /*::-webkit-scrollbar{width:4px;}
    ::-webkit-scrollbar-track{background-color:rgba(51,51,51,0.7);}
    ::-webkit-scrollbar-thumb{background-color:#00aff0;}*/
</style>
